/** Catch-all 404 page. No routes work other than the landing page. */
export function NotFound() {
  return (
    <main className="site site-light site-error">
      <img
        className="site-logo"
        src="/brand/logo.png"
        alt="Asset Integrity Solutions, LLC"
        width={220}
        height={220}
      />
      <div className="site-body">
        <p className="site-eyebrow">Error 404</p>
        <h1 className="site-title">Page not found</h1>
        <p className="site-text">
          You may have mistyped the address or the page may have moved.
        </p>
      </div>
      <footer className="site-footer">
        &copy; {new Date().getFullYear()} Asset Integrity Solutions, LLC. All rights reserved.
      </footer>
    </main>
  );
}
